// extracted by mini-css-extract-plugin
export default {"container":"jKPNT6O7pp8yiPpq7e43","title":"_JJc5tiFwG7rtNIVgWZ_","message":"jOaEbkjFq7EIguawH1Z3"};